export type ImportGeometriesRequestDto = {
    fileName: string;
    file: string;
    kontraktId: number;
};

export type GenericFeatureInfo = {
    name: string;
    geometryType: string;
    wktGeometry: string;
    attributes: GeometryAttribute[];
    id: string;
    visible: boolean;
    mapColor: any;
};

export type GeometryAttribute = {
    [Key: string]: any;
};

export type ImportedGeometry = {
    atgardGuid?: string;
    name: string;
    geometryType: string;
    wktGeometry: string;
    type: string;
    subtype1?: string;
    subtype2?: string;
    subtype3?: string;
    id?: string;
};

export class ImportSelectData {
    atgGuid?: string;
    constructor(readonly geometryType: string, readonly subtyp1?: string, readonly subtyp2?: string, readonly subtyp3?: string) {
    }
}
